import React from 'react';

const PaperIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="18"
    viewBox="0 0 14 18"
    {...props}
  >
    <path
      fill="none"
      fillRule="evenodd"
      stroke="#020303"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M1.706 2.647c0-.52.421-.941.942-.941h4.391c.52 0 .941.422.941.941v3.137c0 .52.422.941.941.941h3.138c.52 0 .941.422.941.941h0v8.158c0 .52-.421.94-.94.94H2.647c-.52 0-.942-.42-.942-.94V2.647zm5.929-.733l5.18 5.195-5.18-5.195z"
    />
  </svg>
);

export default PaperIcon;
